module.exports = __webpack_public_path__ + "static/media/Tyranitar_gaussian2.58daebf9.png";